import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import axios from 'axios'

// Create a client
export const queryClient = new QueryClient({
   defaultOptions: {
      queries: {
         async queryFn({ queryKey}) {
            const path = queryKey[0]
            const { data } = await axios.get(path)
            return data
         }
      }
   }
})
